<div class="container-fluid tp-box" [@flipState]="flip" >
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">groups</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
			</div>
			<div class="cw-body"  *ngIf="viewing">
				<app-customer-total [data]="viewing"></app-customer-total>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="groups"
				accent="success"
				[value]="total"
				[loading]="!data"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
